import { __decorate, __metadata } from "tslib";
import { DefaultExposeGroupEnum, SupportedCurrencyEnum, VendorProviderEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsInt, IsNotEmpty, IsNumber, IsOptional, IsPositive, IsString, IsUUID } from 'class-validator';
import { PrimaryColumn } from 'typeorm';
import { LoyaltyTransactionSourceTypeEnum } from '../interface';
export class CreateLoyaltyTransactionDto {
}
__decorate([
    ApiProperty({ type: () => String, format: 'uuid', description: 'uuid v4' }),
    PrimaryColumn('uuid'),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    IsUUID('4', { always: true }),
    __metadata("design:type", String)
], CreateLoyaltyTransactionDto.prototype, "transactionUuid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'uuid', description: 'uuid v4', example: '5c489c2e-20fa-4fc1-a550-76a3e27e04d9' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    IsUUID('4', { always: true }),
    __metadata("design:type", String)
], CreateLoyaltyTransactionDto.prototype, "programUuid", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'WESTVILLE_GROUP' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], CreateLoyaltyTransactionDto.prototype, "merchantId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'WESTVILLE_WEST' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsOptional({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], CreateLoyaltyTransactionDto.prototype, "storeId", void 0);
__decorate([
    ApiProperty({ type: () => String, example: '1343534535242456' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], CreateLoyaltyTransactionDto.prototype, "userId", void 0);
__decorate([
    ApiProperty({ enum: VendorProviderEnum, example: VendorProviderEnum.GOPARROT }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsEnum(VendorProviderEnum, { always: true }),
    __metadata("design:type", String)
], CreateLoyaltyTransactionDto.prototype, "provider", void 0);
__decorate([
    ApiProperty({ enum: LoyaltyTransactionSourceTypeEnum, example: LoyaltyTransactionSourceTypeEnum.SYNC }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsEnum(LoyaltyTransactionSourceTypeEnum, { always: true }),
    __metadata("design:type", String)
], CreateLoyaltyTransactionDto.prototype, "sourceType", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    IsOptional({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", String)
], CreateLoyaltyTransactionDto.prototype, "sourceRefId", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 10, description: 'points earned by this transaction' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], CreateLoyaltyTransactionDto.prototype, "pointsEarned", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 10, description: 'points left on this transaction, can be decreased over time by other transactions' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], CreateLoyaltyTransactionDto.prototype, "pointsLeft", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'test store title', description: 'storeTitle of storeId' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsOptional({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], CreateLoyaltyTransactionDto.prototype, "storeTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsOptional({ always: true }),
    IsNumber(undefined, { always: true }),
    IsPositive({ always: true }),
    __metadata("design:type", Number)
], CreateLoyaltyTransactionDto.prototype, "orderTotal", void 0);
__decorate([
    ApiPropertyOptional({ enum: SupportedCurrencyEnum }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsOptional({ always: true }),
    IsNotEmpty({ always: true }),
    IsEnum(SupportedCurrencyEnum, { always: true }),
    __metadata("design:type", String)
], CreateLoyaltyTransactionDto.prototype, "orderCurrency", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], CreateLoyaltyTransactionDto.prototype, "isSynced", void 0);
//# sourceMappingURL=CreateLoyaltyTransactionDto.js.map